const { cELM, Wrap4Arrow } = require("../../utils");
const Chat = require("../../chat");

class List {
  constructor({ id, options, values, type, labels }) {

    this.id = id;
    this.options = options;
    this.labels = labels;
    //this.type = type; //e.g. medications, dosages. This is used for update
    if (Array.isArray(values)) {
      this.data = values;
    } else {
      this.data = [];
      Object.keys(values || {}).forEach(k => this.data.push(values[k]));
    }
    if (options.alphabetical && (labels || []).length > 0) {
      this.data = this.data.sort((x, y) =>
        x[labels[0]] > y[labels[0]] ? 1 : -1
      );
    }
    this._element = cELM("div", "option-block");
    this.selectedOptions = [];
    this.noneAbove = null;
    this.createElement();
  }

  createElement() {
    const _self = this;
    const btnEl = cELM(
      "div",
      "continue-button",
      this.options.buttonName || "Continue"
    );
    const btnWrp = Wrap4Arrow(btnEl);

    if (this.options.selectAll) {
      const selectAll = cELM(
        "a",
        "select-all",
        this.options["selectAll"].label
      );
      this._element.addELM(selectAll);
      selectAll.onclick = () => {
        const allmeds = document.getElementsByClassName("option");
        for (let index = 0; index < allmeds.length; index++) {
          if (!allmeds[index].classList.contains("option-active"))
            allmeds[index].classList.add("option-active");
        }
      };
    }

    if (this.options.deselectAll) {
      const selectNone = cELM(
        "a",
        "deselect-all",
        this.options["deselectAll"].label
      );
      this._element.addELM(selectNone);
      selectNone.onclick = () => {
        const allmeds = document.getElementsByClassName("option");
        for (let index = 0; index < allmeds.length; index++) {
          if (allmeds[index].classList.contains("option-active"))
            allmeds[index].classList.remove("option-active");
        }
        btnEl.classList.add("continue-button-active");
        btnWrp.classList.add("arrow-active");
      };
    }

    this.data.forEach(item => {
      let op =
        typeof item == "string" ? item : (item[this.labels[0]] || "").trim();

      const _el = cELM(
        "div",
        "option" + (this.labels.length > 1 ? " option-border" : "")
      );

      _el.value = op;
      let self = this;
      _el.onclick = function(evt) {
        _el.classList.toggle("option-active");
        if (self.noneAbove) self.noneAbove.classList.remove("option-active");
        let sibling = _el.parentNode.firstChild;
        let selected = false;
        while (sibling) {
          if (sibling.value) {
            if (sibling.classList.contains("option-active")) selected = true;
          }
          sibling = sibling.nextSibling;
        }
        if (selected) {
          btnEl.classList.add("continue-button-active");
          btnWrp.classList.add("arrow-active");
        } else {
          btnEl.classList.remove("continue-button-active");
          btnWrp.classList.remove("arrow-active");
        }
      };

      const checkBox = cELM("div", "option-icon");
      const optionText = cELM("div", "option-text", item[this.labels[0]]);

      _el.addELM(checkBox);
      _el.addELM(optionText);

      this._element.addELM(_el);
      for (let [index, label] of this.labels.entries()) {
        if (index != 0) {
          optionText.addELM(cELM("p", "", item[label]));
        }
      }
    });

    //add none of the above if needed
    if (this.options.noneOftheAbove) {
      const _el_none = cELM(
        "div",
        "option" + (this.labels.length > 1 ? " option-border" : "")
      );
      this.noneAbove = _el_none;
      const checkBox = cELM("div", "option-icon");
      const optionText = cELM(
        "div",
        "option-text",
        "<strong>None of the above</strong>"
      );
      _el_none.addELM(checkBox);
      _el_none.addELM(optionText);
      this._element.addELM(_el_none);
      _el_none.onclick = () => {
        _el_none.classList.toggle("option-active");

        const allmeds = document.getElementsByClassName("option");
        console.log("option", allmeds[8] == _el_none);
        for (let index = 0; index < allmeds.length; index++) {
          if (
            allmeds[index].classList.contains("option-active") &&
            allmeds[index] != _el_none
          )
            allmeds[index].classList.remove("option-active");
        }
        btnEl.classList.add("continue-button-active");
        btnWrp.classList.add("arrow-active");
      };
    }

    btnWrp.onclick = function(evt) {
      if (btnEl.classList.contains("continue-button-active")) {
        btnEl.classList.remove("continue-button-active");
        btnWrp.classList.remove("arrow-active");
        btnWrp.style.display = "none";
        _self.selectedOptions = [];
        let sibling = btnWrp.parentNode.firstChild;
        while (sibling) {
          if (
            sibling.value &&
            sibling.classList.contains("option-active") &&
            sibling.value != ((this.options || {}).noneOftheAbove || {}).label
          ) {
            _self.selectedOptions.push(sibling.value);
          }

          sibling = sibling.nextSibling;
        }

        Chat.default.update({
            ..._self.selectedOptions,
            id: _self.id
          },
          null, 
          _self.element
        );
      }
    };

    this._element.addELM(btnWrp);
  }

  getELM() {
    return this._element;
  }

  getHTML() {
    return this._element;
  }

  reset() {
    let sibling = this._element.firstChild;
    while (sibling) {
      sibling.classList.remove("option-active");
      sibling.classList.remove("continue-button-active");
      sibling.classList.remove("arrow-active");

      sibling = sibling.nextSibling;
    }
    this.selectedOptions = [];
  }

  focus() {}
}

module.exports = List;
